import React, { useState, useEffect } from "react";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
var ActivityDetails = function ActivityDetails() {
  return /*#__PURE__*/_jsx(_Fragment, {});
};
export default ActivityDetails;